export default "__VITE_ASSET__CFCZ7HeH__"